export const queryToObject = (queryString: string) => {
  const params = new URLSearchParams(queryString);
  const parseValue = (value: string) => {
    if (value === "true") return true;
    if (value === "false") return false;
    if (!isNaN(+value) && value.trim() !== "") return Number(value);
    return value;
  };
  const queryObject: { [key: string]: string | number | boolean } = {};
  params.forEach((value, key) => {
    queryObject[key] = parseValue(value);
  });
  return queryObject;
};
